const textEncoder = new TextEncoder();

const base64UrlEncode = (input: ArrayBuffer | string): string => {
  const bytes =
    typeof input === 'string'
      ? textEncoder.encode(input)
      : new Uint8Array(input);
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/=+$/, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
};

export interface TestJwtPayload {
  [claim: string]: unknown;
}

/**
 * Signs an HS256 JWT in the browser using the Web Crypto API. Intended only
 * for the dev-only test-login flow (`VITE_TEST_LOGIN_ENABLED=true`) — the
 * shared secret is non-sensitive.
 */
export const signTestJwt = async (
  payload: TestJwtPayload,
  secret: string,
): Promise<string> => {
  const header = { alg: 'HS256', typ: 'JWT' };
  const headerPart = base64UrlEncode(JSON.stringify(header));
  const payloadPart = base64UrlEncode(JSON.stringify(payload));
  const signingInput = `${headerPart}.${payloadPart}`;

  const key = await crypto.subtle.importKey(
    'raw',
    textEncoder.encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign'],
  );
  const signature = await crypto.subtle.sign(
    'HMAC',
    key,
    textEncoder.encode(signingInput),
  );

  return `${signingInput}.${base64UrlEncode(signature)}`;
};
